export enum TurnstileStatuses {
  ERROR = 0,
  READY = 1,
  WATING = 2,
  TIMEOUT = 3,
  ROTATED = 4,
  UNAUTH = 5,
  BUTTON = 6,
}
